import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import AuthRoute from '../../component/authroute';
import Header from '../../component/dashboard/header';
import LeftPanel from '../../component/dashboard/leftPanel';
import MainPanel from '../../component/dashboard/mainPanel';
import PageFooter from '../../component/dashboard/pageFooter';
import Home from './model/home';
import SubscriberCon from './model/subscriberCon';
import bounceEmailCon from './model/bounceEmailCon';
import Subscription from './model/subscription';
import Tenant from './model/tenant';
import TenantDetail from './model/tenantDetail';
import { getOneTenant, getTenantList, updateInfo } from "../../redux/reducer/tenant";
import bodyImg from '../../assets/img/mybg.png';
import {checkdomain} from "../../utils/utils";

@withRouter
@connect(
  state=>state.tenant,
  { getOneTenant, getTenantList, updateInfo }
)
class Dashboard extends Component{
  constructor(props) {
    super(props);
  }
  componentWillMount() {
    let { getOneTenant, getTenantList, updateInfo } = this.props;
    let tenantname = location.hostname.split('.')[0].split('-')[0];
    if (checkdomain(tenantname)) {
      let body = {
        currentPage: 1,
        pageSize: 100
      };
      updateInfo({loginAdmin: "isos"});
      getTenantList(body);
    } else {
      updateInfo({loginAdmin: tenantname});
      getOneTenant({}, {headers: {'tenantname': tenantname}});
    }
  }
  componentDidMount() {
    $("body").css({
      "position": "static",
      "background": `url(${bodyImg}) #fff`
    });
    $("html").scrollTop(0);
  }
  componentWillUnmount() {
    $("body").css({
      "position": "absolute",
      "background": "#fff"
    });
  }
  render() {
    return (
      <div>
        <AuthRoute />
        <Header />
        <LeftPanel />
        <div id="main" role="main">
          <Switch>
            <Route path="/admin/dashboard" component={Home} />
            <Route exact path="/admin/subscribers" component={SubscriberCon} />
            <Route exact path="/admin/subscribers/subscription/:id" component={Subscription} />
            <Route exact path="/admin/bounceEmail" component={bounceEmailCon} />
            <Route exact path="/admin/tenant" component={Tenant} />
            <Route exact path="/admin/tenant/detail/:id" component={TenantDetail} />
            <Route exact path="/admin/tenant/addTenant" component={TenantDetail} />
          </Switch>
          <MainPanel />
        </div>
        <PageFooter />
      </div>
    );
  }
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/container/dashboard/index.js